export default {
  mount: '.icon-add',
  attrs: {
    viewBox: '0 0 24 24',
    fill: 'currentColor'
  },
  path: '<polygon points="19 13 13 13 13 19 11 19 11 13 5 13 5 11 11 11 11 5 13 5 13 11 19 11"></polygon>'
}
